import { useContext, useEffect, useState, useRef } from "react";
import GlobalContext from "../context/GlobalContext";
import { Link, useLocation } from "react-router-dom";
import NotificationService from "../services/NotificationService";
import SearchBar from "./SearchBar";
import Login from "../popups/Login/Login";
import Signup from "../popups/Signup/Signup";
import SignupOtp from "../popups/SignupOtp/SignupOtp";
import LoginOtp from "../popups/LoginOtp/LoginOtp";
import ResetPasswordOtp from "../popups/ResetPasswordOtp/ResetPasswordOtp";
import SignupUserName from "../popups/SignupUserName/SignupUserName";
import ForgotPassword from "../popups/ForgotPassword/ForgotPassword";
import ChangePassword from "../popups/ChangePassword/ChangePassword";
import NewPassword from "../popups/NewPassword/NewPassword";
import Feedback from "../popups/Feedback/Feedback";
import ReferAndEarn from "../popups/ReferAndEarn/ReferAndEarn";
import WellcomeCookie from "../popups/WellcomeCookie/WellcomeCookie";
import Wallet from "../popups/Wallet/Wallet";
import moment from "moment";
import SocialSignupLogin from "../popups/SocialSignupLogin/SocialSignupLogin";
const notifyServ = new NotificationService();
function Header() {
  const globalCtx = useContext(GlobalContext);
  const [isAuthentiCated, setIsAuthentiCated] = globalCtx.auth;
  const [passwordToken, setPasswordToken] = globalCtx.passwordToken;
  const [referToken, setReferToken] = globalCtx.referToken;
  const [referEarn, setReferEarn] = globalCtx.referEarn;
  const [showLoginSignup, setShowLoginSignup] = globalCtx.showLoginSignup; // this is to consume events form LoginSignupCard
  const [user, setUser] = globalCtx.user;
  const [setting, setSetting] = globalCtx.setting;
  const [toggleNewPaswrd, setToggleNewPaswrd] = useState(false);
  const [showChangePaswrdPopup, setShowChangePaswrdPopup] = useState(false);
  const [showChangePaswrdOtpPopup, setShowChangePaswrdOtpPopup] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showSocialLoginPopup, setShowSocialLoginPopup] = useState(false);
  const [showLoginOtpPopup, setShowLoginOtpPopup] = useState(false);
  const [showSignupPopup, setShowSignupPopup] = useState(false);
  const [showSignupOtpPopup, setShowSignupOtpPopup] = useState(false);
  const [showSignupUserNamePopup, setShowSignupUserNamePopup] = useState(false);
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
  const [showCokiePopup, setShowCokiePopup] = useState(false);
  const [showFPPopup, setShowFPPopup] = useState(false);
  const [userProfile, setUserProfile] = useState({});
  const [notificationList, setNotificationList] = useState([]);
  const [selectedNav, setSelectedNav] = useState(null);
  const [showBG, setShowBG] = useState(false);
  const [showWalletPopup, setShowWalletPopup] = useState(false);
  const [resetOtp, setResetOtp] = useState({});
  const [socialType, setSocialType] = useState("");
  const [showNotificationDropdown, setShowNotificationDropdown] = useState(false);
  let location = useLocation();

  useEffect(() => {
    handleActive();
  }, [location]);
  useEffect(() => {
    getNotificationList();
  }, []);
  useEffect(() => {
    getNotificationList();
    document.addEventListener("click", handleOutSide, true);
  }, []);
  const refOne = useRef(null);
  const handleOutSide = (e) => {
    if (!refOne.current.contains(e.target)) {
      setShowNotificationDropdown(false);
    } else {
      setShowNotificationDropdown(true);
    }
  };
  async function getNotificationList() {
    let filter = { type: "web" };
    let respData = await notifyServ.listAll({ filter });
    setNotificationList(respData.data);
  }

  const handleActive = () => {
    if (location.pathname.includes("profile")) {
      setSelectedNav("/profile");
    } else if (location.pathname.includes("support")) {
      setSelectedNav("/support");
    } else {
      setSelectedNav(null);
    }
  };
  function showLogin() {
    setShowLoginPopup(!showLoginPopup);
  }
  function showSocialLogin() {
    setShowSocialLoginPopup(!showSocialLoginPopup);
  }
  function showRefer() {
    setReferEarn(!referEarn);
  }
  function showSignup() {
    setShowSignupPopup(!showSignupPopup);
  }
  function showSignupUserName() {
    setShowSignupUserNamePopup(!showSignupUserNamePopup);
  }
  function showSignupOtp() {
    setShowSignupOtpPopup(!showSignupOtpPopup);
  }
  function showLoginOtp() {
    setShowLoginOtpPopup(!showLoginOtpPopup);
  }
  function showFeedback() {
    setShowFeedbackPopup(!showFeedbackPopup);
  }
  function showWellcomeCokie() {
    setShowCokiePopup(!showCokiePopup);
  }
  function showFP() {
    setShowFPPopup(!showFPPopup);
  }
  function showChangePaswrdOtp() {
    setShowChangePaswrdOtpPopup(!showChangePaswrdOtpPopup);
  }
  function showWallet() {
    setShowWalletPopup(!showWalletPopup);
  }
  function showChangePassword() {
    setShowChangePaswrdPopup(!showChangePaswrdPopup);
  }
  useEffect(() => {
    if (passwordToken) {
      showNewPassword();
    }
    if (!isAuthentiCated && referToken) {
      showSignup();
    }
  }, [passwordToken, referToken]);

  useEffect(() => {
    if (showLoginSignup.value == "login") {
      setShowLoginPopup(true);
    } else if (showLoginSignup.value == "signup") {
      setShowSignupPopup(true);
    }
  }, [showLoginSignup]);

  useEffect(() => {
    if (referEarn) {
      setReferEarn(true);
    }
  }, [referEarn]);
  function showNewPassword() {
    setToggleNewPaswrd(!toggleNewPaswrd);
  }
  const logoutHandler = () => {
    // localStorage.clear();
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    setIsAuthentiCated(false);
    setUser(null);
  };

  useEffect(() => {
    setUserProfile(user);
  }, [user]);
  useEffect(() => {
    let preDate = localStorage.getItem("accessDate");
    if (preDate !== null) {
      var a = moment(new Date());
      var b = moment(preDate);
      let diffDay = a.diff(b, "days");
      if (diffDay > 30) {
        setShowCokiePopup(true);
      }
    } else {
      setShowCokiePopup(true);
    }
    localStorage.setItem("accessDate", new Date());
  }, []);
  async function handleAllRead() {
    const resp = await notifyServ.MarkNotificationAsRead({});
    getNotificationList();
  }
  const handleReadById = async (id) => {
    let response = await notifyServ.MarkById(id);
    if (response.message) {
      getNotificationList();
    }
  };
  return (
    <div className="contantSection">
      <header className="w-100 topHeaderSection bg-white">
        <div className="topHeaderInner d-flex align-items-center w-100">
          <div className="logoColumn d-flex d-lg-none">
            <Link to="/" className="d-block">
              <img
                src={setting?.brand?.header_logo || "/images/svg-icons/betalogo.svg"}
                alt="logo"
                className="img-fluid img-unselect"
              />
            </Link>
          </div>
          <SearchBar />
          {!isAuthentiCated && (
            <div className="headerMenu ms-lg-auto">
              <div className="headerSignUp">
                <a href="#" className="btn btnLogin" onClick={showLogin}>
                  Login
                </a>
                <a href="#" className="btn btnSignup" onClick={showSignup}>
                  Sign up
                </a>
              </div>
            </div>
          )}
          {isAuthentiCated && (
            <>
              <div className="headerMenu ms-lg-auto">
                <div className="headerBtnSection d-flex align-items-center">
                  <div className="headerBtnSec d-flex">
                    <div className="modeBtn">
                      {setting?.general?.is_refer_reward_on &&
                        (referEarn ? (
                          <Link
                            className="headerBookmark headerIcon"
                            to="#"
                            onClick={showRefer}
                            style={{ background: "#727B82" }}
                          >
                            <img src="/images/svg-icons/refer-white.svg" />
                          </Link>
                        ) : (
                          <Link className="headerBookmark headerIcon" to="#" onClick={showRefer}>
                            <img src="/images/svg-icons/refer.svg" />
                          </Link>
                        ))}
                      <input type="hidden" id="activeModelIcon" value="activeModelIcon" />
                    </div>
                    <div className="modeBtn">
                      {showWalletPopup ? (
                        <Link
                          style={{ background: "#727B82" }}
                          className="headerBookmark headerIcon"
                          to="#"
                          onClick={showWallet}
                        >
                          <img src="/images/svg-icons/wallet-white.svg" />
                        </Link>
                      ) : (
                        <Link className="headerBookmark headerIcon" to="#" onClick={showWallet}>
                          <img src="/images/svg-icons/wallet-grey.svg" />
                        </Link>
                      )}
                      <input type="hidden" id="activeModelIcon" value="activeModelIcon" />
                    </div>
                    <div className="modeBtn dropdown modeBtnNotify">
                      <a
                        href="javascript:void(0)"
                        className="headerNotification headerIcon"
                        onClick={() => setShowNotificationDropdown(!showNotificationDropdown)}
                      >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.0002 1.66675C9.31016 1.66675 8.75016 2.22675 8.75016 2.91675V3.49618C6.59448 4.05183 5.00016 6.00408 5.00016 8.33341V13.3334L3.3335 15.0001V15.8334H8.55811C8.41136 16.0867 8.3339 16.3741 8.3335 16.6667C8.3335 17.1088 8.50909 17.5327 8.82165 17.8453C9.13421 18.1578 9.55814 18.3334 10.0002 18.3334C10.4422 18.3334 10.8661 18.1578 11.1787 17.8453C11.4912 17.5327 11.6668 17.1088 11.6668 16.6667C11.6659 16.3739 11.5879 16.0865 11.4406 15.8334H16.6668V15.0001L15.0002 13.3334V8.33341C15.0002 6.00408 13.4058 4.05183 11.2502 3.49618V2.91675C11.2502 2.22675 10.6902 1.66675 10.0002 1.66675ZM10.0002 5.00008C11.8385 5.00008 13.3335 6.49508 13.3335 8.33341V13.3334V14.0235L13.4767 14.1667H6.5236L6.66683 14.0235V13.3334V8.33341C6.66683 6.49508 8.16183 5.00008 10.0002 5.00008Z" />
                        </svg>
                      </a>
                      <div
                        ref={refOne}
                        className={
                          "bellNotification dropdown-menu  dropdownShadow" + (showNotificationDropdown ? " show" : " ")
                        }
                        style={{ marginRight: "300px", marginTop: "10px" }}
                      >
                        <div
                          className="bellNotifyTopHead bellNotifyTopHeadCustom notificationHeader "
                          style={{ borderBottom: "1px solid rgba(114, 123, 130, 0.25)" }}
                        >
                          <div className="bellNotifyTopHeading">
                            <h2 className="mb-0 letterSpacing0">Notifications</h2>
                          </div>
                          <div className="bellNotifyHeadRight">
                            {notificationList.filter((item) => !item.isRead).length > 0 && (
                              <a href="javascript:void(0);" onClick={handleAllRead} className="letterSpacing0 darkColr">
                                Mark all as read
                              </a>
                            )}
                            <div className="bellNotifyCloseBox" onClick={() => setShowNotificationDropdown(false)}>
                              <a href="javascript:void(0);" className="darkColr">
                                <img src="/images/svg-icons/closeBorder.svg" alt="closeIcon" className="img-fluid" />
                              </a>
                            </div>
                          </div>
                        </div>
                        {notificationList.length > 0 ? (
                          <div className="bellNotifyGroup">
                            {notificationList.map((item) => (
                              <a
                                href="javascript:void(0);"
                                className="disBlock"
                                onClick={() => handleReadById(item._id)}
                              >
                                <div className={"bellNotify notifyPadding" + (!item.isRead ? " activeNBg" : "")}>
                                  <div className="bellNotifyHead">
                                    <div className="bellNotifyHeading">
                                      <h5 className="mb-0 d-flex letterSpacing0">
                                        {!item.isRead && <div className="notifyState"></div>}
                                        <div className="notifyHeading letterSpacing0" style={{ letterSpacing: "0px" }}>
                                          {item.title}
                                        </div>
                                      </h5>
                                    </div>
                                    <div className="bellNotifyTime">
                                      <p className="mb-0 letterSpacing0">{moment(item.createdAt).fromNow()}</p>
                                    </div>
                                  </div>
                                  <div className="bellNotifyPara">
                                    <p className="mb-0 letterSpacing0">{item.content}</p>
                                  </div>
                                </div>
                              </a>
                            ))}
                          </div>
                        ) : (
                          <div className="bellNotifyGroup bellNotifyGroupEmpty">
                            <img src="/images/svg-icons/notification_black.svg" />
                            <h2 className="letterSpacing0">No new notifications</h2>
                            <p className="letterSpacing0">
                              Looks like there are no new notifications for you!
                              <br />
                              Please check again later.
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="modeBtn">
                      <Link
                        className={"headerBookmark headerIcon " + (location.pathname == "/bookmarks" && "show")}
                        to="/bookmarks"
                      >
                        {/* <a
                          href="none"
                          className="headerBookmark headerIcon"
                        > */}
                        <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.00684 0.333328C1.27653 0.333328 0.673503 0.935061 0.673503 1.66536L0.666992 13.6667L6.00033 11.6667L11.3337 13.6667V12.7044V1.66666C11.3337 0.937953 10.729 0.333328 10.0003 0.333328H2.00684ZM2.00684 1.66666H10.0003V11.7422L6.00033 10.2422L2.00163 11.7422L2.00684 1.66666Z" />
                        </svg>
                        {/* </a> */}
                      </Link>
                      <input type="hidden" id="activeModelIcon" value="activeModelIcon" />
                    </div>
                    <div className="modeBtn d-none d-lg-block modeActive">
                      <a
                        href="javascript:void(0)"
                        className="headerSetting headerIcon"
                        data-bs-toggle="modal"
                        data-bs-target="#settingsPopup"
                      >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.05518 1.66675L7.64665 3.76961C6.95984 4.02863 6.32915 4.39169 5.77653 4.84546L3.75667 4.14884L1.81006 7.51798L3.4279 8.92423C3.3657 9.30609 3.3335 9.65995 3.3335 10.0001C3.3335 10.3407 3.36667 10.6939 3.4279 11.0759V11.0776L1.81006 12.4838L3.75667 15.8513L5.7749 15.1563C6.32758 15.6103 6.95969 15.9714 7.64665 16.2305L8.05518 18.3334H11.9452L12.3537 16.2305C13.0409 15.9714 13.6709 15.6089 14.2238 15.1547L16.2437 15.8513L18.1886 12.4838L16.5724 11.0759C16.6346 10.6941 16.6668 10.3402 16.6668 10.0001C16.6668 9.66046 16.6344 9.30706 16.5724 8.92586V8.92423L18.1903 7.51636L16.2437 4.14884L14.2254 4.84383C13.6728 4.38982 13.0406 4.02878 12.3537 3.76961L11.9452 1.66675H8.05518ZM9.42887 3.33341H10.5715L10.8953 5.00008L11.7645 5.32886C12.2884 5.52631 12.7591 5.79738 13.1675 6.13289L13.8869 6.72209L15.4884 6.17196L16.0597 7.15991L14.7804 8.27319L14.9269 9.18953V9.19116C14.9779 9.50361 15.0002 9.76572 15.0002 10.0001C15.0002 10.2344 14.9779 10.4965 14.9269 10.809L14.7788 11.7253L16.0581 12.8386L15.4868 13.8282L13.8869 13.2764L13.1659 13.8673C12.7574 14.2028 12.2884 14.4739 11.7645 14.6713H11.7629L10.8937 15.0001L10.5698 16.6667H9.42887L9.10498 15.0001L8.23584 14.6713C7.71195 14.4739 7.24127 14.2028 6.83285 13.8673L6.11344 13.2781L4.51188 13.8282L3.94059 12.8403L5.22152 11.7253L5.07341 10.8123V10.8106C5.02318 10.4968 5.00016 10.234 5.00016 10.0001C5.00016 9.76572 5.02245 9.50365 5.07341 9.19116L5.22152 8.27482L3.94059 7.16154L4.51188 6.17196L6.11344 6.72371L6.83285 6.13289C7.24127 5.79738 7.71195 5.52631 8.23584 5.32886L9.10498 5.00008L9.42887 3.33341ZM10.0002 6.66675C8.16973 6.66675 6.66683 8.16965 6.66683 10.0001C6.66683 11.8305 8.16973 13.3334 10.0002 13.3334C11.8306 13.3334 13.3335 11.8305 13.3335 10.0001C13.3335 8.16965 11.8306 6.66675 10.0002 6.66675ZM10.0002 8.33341C10.9264 8.33341 11.6668 9.07385 11.6668 10.0001C11.6668 10.9263 10.9264 11.6667 10.0002 11.6667C9.07393 11.6667 8.3335 10.9263 8.3335 10.0001C8.3335 9.07385 9.07393 8.33341 10.0002 8.33341Z" />
                        </svg>
                      </a>
                      <input type="hidden" id="activeModelIcon" value="activeModelIcon" />
                    </div>
                    <div className="modeBtn d-block d-lg-none">
                      <a href="javascript:void(0)" className="headerSearch">
                        <img src="/images/svg-icons/search.svg" alt="search" className="img-fluid" />
                      </a>
                    </div>
                  </div>
                  {userProfile && (
                    <>
                      {showBG && (
                        <div
                          className="modal-backdrop show"
                          onClick={() => {
                            // setShowBG(!showBG);
                          }}
                        ></div>
                      )}
                      <div className="userProfile d-none d-lg-block">
                        <div className="dropdown">
                          <a
                            type="button"
                            className="btn btnProf dropdown-toggle"
                            data-bs-toggle="dropdown"
                            onClick={() => {
                              // setShowBG(!showBG);
                            }}
                          >
                            <img
                              src={userProfile.file || "/images/svg-icons/blank-profile.svg"}
                              alt="doodle"
                              className="img-fluid"
                              style={{ width: "26px", borderRadius: "8px", height: "26px" }}
                            />
                            <span className="d-none d-sm-block">{userProfile.user_name}</span>
                          </a>
                          <ul
                            className="dropdown-menu userProfile-dropDown dropdownShadow userProfile-dropdown-custom"
                            onClick={() => {
                              // setShowBG(!showBG);
                            }}
                          >
                            <li>
                              <div className="dropDown-profile">
                                <div>
                                  <div className="name">{userProfile.full_name}</div>
                                  <div className="userName">
                                    {userProfile.user_name ? (
                                      <span>@{userProfile.user_name}</span>
                                    ) : (
                                      <span>@alpha</span>
                                    )}
                                  </div>
                                  {/* <div className="email">
                                    {userProfile?.email?.length > 14 ? (
                                      <span
                                        className="d-inline-block"
                                        tabindex="0"
                                        data-toggle="tooltip"
                                        title={userProfile.email}
                                      >
                                        {userProfile.email.slice(0, 14) + "..."}
                                      </span>
                                    ) : (
                                      userProfile.email
                                    )}
                                  </div> */}
                                </div>
                                <img
                                  src={userProfile.file || "/images/svg-icons/blank-profile.svg"}
                                  alt="doodle"
                                  className="img-fluid dropDown-profile-image"
                                  style={{ width: "54px", height: "54px" }}
                                />
                              </div>
                            </li>
                            {/* <hr />
                            <li>
                              <div className="dropDown-balance">
                                <div className="dropDown-balance-title">
                                  <img
                                    src={"/images/svg-icons/mave-logo.svg"}
                                    alt="doodle"
                                    className="img-fluid"
                                    width={20}
                                  />
                                  <p className="profile-balance-title">
                                    Balance:
                                  </p>
                                </div>
                                <div className="dropDown-balance-value">
                                  <p className="profile-balance-value">
                                    {user.reward} COINS
                                  </p>
                                </div>
                              </div>
                            </li> */}
                            <hr className="hrCustom" />
                            <li>
                              <Link
                                className={
                                  "dropdown-item dropdown-item-custom " +
                                  (selectedNav == "/profile" ? " dropdown-item-custom-active" : "")
                                }
                                to="/profile"
                              >
                                <img src="/images/svg-icons/user.svg" alt="dropdownIcon" className="img-fluid" />{" "}
                                Profile{" "}
                              </Link>
                            </li>
                            <li>
                              <Link className="dropdown-item disabled" to="#">
                                <img
                                  src="/images/svg-icons/pro.svg"
                                  alt="dropdownIcon"
                                  className="img-fluid dropdown-item-disable"
                                />
                                <span className="dropdown-item-disable">Go Pro</span>
                                <span className="inactive-comingSoon">Coming Soon</span>
                              </Link>
                            </li>
                            <li>
                              <Link className="dropdown-item dropdown-item-custom" to="#" onClick={showFeedback}>
                                <img src="/images/svg-icons/feedback.svg" alt="dropdownIcon" className="img-fluid" />
                                Feedback
                              </Link>
                            </li>
                            <li>
                              <Link
                                className={
                                  "dropdown-item dropdown-item-custom" +
                                  (selectedNav == "/support" ? " dropdown-item-custom-active" : "")
                                }
                                to="/support"
                              >
                                <img
                                  src="/images/svg-icons/help-support.svg"
                                  alt="dropdownIcon"
                                  className="img-fluid"
                                />
                                Support
                              </Link>
                            </li>
                            <hr className="hrCustom" />
                            <li>
                              <Link
                                className="dropdown-item dropdown-item-custom changePasswordCustom"
                                to="#"
                                onClick={showChangePassword}
                              >
                                <img
                                  src="/images/svg-icons/changePassword.svg"
                                  alt="dropdownIcon"
                                  className="img-fluid"
                                />
                                Change Password
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item disconnect disconnect-custom"
                                to=""
                                onClick={logoutHandler}
                              >
                                <img src="/images/svg-icons/signout.svg" alt="dropdownIcon" className="img-fluid" />{" "}
                                Sign out
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="toggleBtn  d-inline-block-block d-lg-none">
                <button
                  className="navbar-toggler btn"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapsibleNavbar"
                >
                  <span className="line1"></span>
                  <span className="line2"></span>
                  <span className="line3"></span>
                </button>
              </div>
            </>
          )}
        </div>
      </header>
      {showSignupPopup && (
        <Signup
          onClose={() => {
            showSignup();
          }}
          onFinish={() => {
            showSignup();
            showSignupOtp();
          }}
          onShowLogin={() => {
            showSignup();
            showLogin();
          }}
          handleShowSocialLogin={() => {
            showSignup();
            setSocialType("signup");
            showSocialLogin();
          }}
        />
      )}
      {showLoginPopup && (
        <Login
          onClose={showLogin}
          onShowSignup={() => {
            showLogin();
            showSignup();
          }}
          onShowForgotPassword={() => {
            showLogin();
            showFP();
          }}
          handleShowSocialLogin={() => {
            showLogin();
            setSocialType("login");
            showSocialLogin();
          }}
          setOtp={setShowLoginOtpPopup}
        />
      )}
      {showSocialLoginPopup && (
        <SocialSignupLogin
          onClose={() => {
            showSocialLogin();
          }}
          onFinish={() => {
            showSocialLogin();
          }}
          socialType={socialType}
          onShowLogin={() => {
            showSocialLogin();
            showLogin();
          }}
          onShowSignup={() => {
            showSocialLogin();
            showSignup();
          }}
        />
      )}
      {showSignupOtpPopup && (
        <SignupOtp
          onClose={() => {
            showSignupOtp();
          }}
          onFinish={() => {
            showSignupOtp();
            showSignupUserName();
          }}
          onEdit={() => {
            showSignupOtp();
            showSignup();
          }}
        />
      )}
      {showSignupUserNamePopup && (
        <SignupUserName
          onClose={() => {
            showSignupUserName();
          }}
        />
      )}
      {showFPPopup && (
        <ForgotPassword
          onClose={showFP}
          onFinish={(obj) => {
            showFP();
            setResetOtp({ ...obj });
            showChangePaswrdOtp();
          }}
        />
      )}
      {toggleNewPaswrd && (
        <NewPassword
          token={passwordToken}
          otpDetail={resetOtp}
          onClose={showNewPassword}
          onFinish={() => {
            showNewPassword();
            showLogin();
          }}
        />
      )}
      {showChangePaswrdOtpPopup && (
        <ResetPasswordOtp
          otpDetail={resetOtp}
          onClose={(obj) => {
            showChangePaswrdOtp();
            setResetOtp({ ...obj });
            showNewPassword();
          }}
          // onFinish={() => {
          //   showNewPassword();
          //   showLogin();
          // }}
        />
      )}
      {showChangePaswrdPopup && (
        <ChangePassword
          onClose={showChangePassword}
          // onFinish={() => {
          //   showNewPassword();
          //   showLogin();
          // }}
        />
      )}
      {isAuthentiCated && referEarn && <ReferAndEarn userId={user._id} onClose={showRefer} />}
      {showFeedbackPopup && <Feedback userId={user._id} onClose={showFeedback} />}
      {showCokiePopup && <WellcomeCookie onClose={showWellcomeCokie} />}
      {showWalletPopup && <Wallet userId={user._id} onClose={showWallet} />}
      {!showLoginPopup && showLoginOtpPopup && (
        <LoginOtp
          onClose={() => {
            showLoginOtp();
          }}
          onEdit={() => {
            showLoginOtp();
            showLogin();
          }}
        />
      )}
    </div>
  );
}

export default Header;
